var creditStatusRanges = {
    excellent: {
        min: 781,
        max: 850,
    },
    veryGood: {
        min: 720,
        max: 780,
    },
    good: {
        min: 658,
        max: 719,
    },
    fair: {
        min: 601,
        max: 657,
    },
    poor: {
        min: 300,
        max: 600,
    },
};
var getCreditStatus = function (creditScore) {
    var status = Object.keys(creditStatusRanges).filter(function (key) {
        return (creditScore <= creditStatusRanges[key].max &&
            creditScore >= creditStatusRanges[key].min);
    })[0];
    return status;
};
export default getCreditStatus;
